<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item active"><a href="">БАЗОВАЯПРОГРАММА </a></li>
            <li class="tab-menu__item"><a href="">РАСШИРЕННАЯПРОГРАММА</a></li>
            <li class="tab-menu__item"><a href="">РАСШИРЕННАЯПРОГРАММА ПРЕМИУМ</a></li>
            <li class="tab-menu__item"><a href="">РАСШИРЕННАЯПРОГРАММА ДИАМАНТ</a></li>
            <li class="tab-menu__item"><a href="">Дополнительные обследования </a></li>
        </ul>
    </div>
    <div class="tab-menu-con">
        <div class="tab-content active">
            <div class="lang">
                <div class="info">
                    <div class="table">
                        <table>
                            <caption>BASIC</caption>
                            <colgroup>
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                                <col style="width: auto">
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="4">Наименование обследований</th>
                                    <th scope="col" colspan="2">Стоимость</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th sope="rowgroup" rowspan="12" class="br" style="border-right: 1px solid #d9d9d9;">Базовые<br>обследования</th>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Основные физические<br>показатели</span>
                                    </th>
                                    <td class="left">Антропометрические данные: рост, вес, анализ строения тела
                                        (определение соотношения мышечной ижировой тканей), кровяное давление</td>
                                    <td rowspan="11">
                                        Мужчины<br>
                                        1,050,000
                                        <br>
                                        вон
                                    </td>
                                    <td rowspan="11">
                                        Женщины<br>
                                        1,300,000<br>
                                        вон
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Диагностика слуха</span>
                                    </th>
                                    <td class="left">Аудиометрия чистого тона (проверка слуха)</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Офтальмологическое<br>обследование</span>
                                    </th>
                                    <td class="left">Острота зрения, внутриглазное давление, офтальмоскопия (проверка
                                        глазного дна)</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Исследование<br>функций сердца и<br>легких</span>
                                    </th>
                                    <td class="left">Pентгенография грудной клетки, электрокардиография
                                        (ЭКГ) сердца</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Анализ кала и мочи</span>
                                    </th>
                                    <td class="left">Микроскопическое исследование осадка мочи, анализ кала на скрытую
                                        кровь</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Анализ крови</span>
                                    </th>
                                    <td class="left">
                                        Общеклинический анализ крови (эритроциты, лейкоциты, гемоглобин, гематокрит,
                                        ширина распределения эритроцитов по объёму, тромбоциты, средний объем
                                        эритроцитов, среднее содержание гемоглобина в
                                        эритроцитах)<br>
                                        Группа крови (определение группыкрови и резус- принадлежность)<br>
                                        Уровень витамина Д<br>
                                        Диагностика сахарного диабета (уровень глюкозы, гликозилированного гемоглобина
                                        (HbA1C)<br>
                                        Исследование функции печени (общий белок, альбумин, АСТ, АЛТ, щелочная
                                        фосфатаза, гамма-гт, общий
                                        билирубин, прямой билирубин)<br>
                                        Определение антител к вирусу гепатита A/B/C<br>
                                        Определение фактора риска развития ишемической болезни сердца (гомоцистеин,
                                        С-реактивный
                                        белок (СРБ), креатинкиназа, аполипопротеин А1, аполипопротеин В)<br>
                                        Диагностика гиперлипидемии (общий холестерин, липопротеидынизкой и высокой
                                        плотности, триглицериды, лактатдегидрогеназа)<br>
                                        Исследование фунции щитовиднойжелезы: анализ гормонов щитовиднойжелезы
                                        (Трийодтиронин (Т3),
                                        Тироксин свободный (Т4 свободный)., тиреотропный гормон (ТТГ))<br>
                                        Исследование функции почек (азот мочевины крови, креатинин). Биохимический
                                        анализ крови на электролиты (кальций, калий, натрий, хлориды, фосфор, диоксид
                                        углерода)<br>
                                        Диагностика подагры (уровень мочевой кислотыв крови)<br>
                                        Иммуносерологическое исследование (ревматоидный
                                        фактор, лабораторный тест на венерические заболевания (сифилис), тест на ВИЧ<br>
                                        Исследование функции поджелудочнойжелезы (уровень панкреатической амилазыи
                                        липазыв крови)<br>
                                        Онкомаркеры: печень (альфа-фетопротеин, AФП);
                                        желудочно-кишечный тракт (раково-эмбриональный антиген, РЭА);
                                        поджелудочнаяжелеза (раковый антиген CA 19-9); яичники (женщины) (раковый
                                        антиген CA125); предстательнаяжелеза (мужчины) (простат- специфический
                                        антиген (ПСА), свободный ПСА), Антиген
                                        плоскоклеточной карциномы (SCC)
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Диагностика<br>онкологиижелудка</span>
                                    </th>
                                    <td class="left">Эзофагогастродуоденоскопия (ЭГДС)</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>УЗИ (Ультразвуковое<br>
                                            исследование)</span>
                                    </th>
                                    <td class="left">Ультразвуковое исследование (УЗИ) органов брюшной полости</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Обследования на<br>выбор (выбрать одно)</span>
                                    </th>
                                    <td class="left">Ультразвуковое исследование (УЗИ) щитовидной
                                        железыИЛИнизко-дозная компьютерная томография
                                        (КТ) легких</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Обследования для<br>женщин</span>
                                    </th>
                                    <td class="left">Цитологическое исследование шейки матки (ПАП тест),
                                        гинекологическое УЗИ, тест на вирус папилломы человека, маммография</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Другое</span>
                                    </th>
                                    <td class="left">Kонсультация по физической культуре, денситометрия костной ткани
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p class="font-sub mt20">
                        * Женщинам в возрасте до 35 лет, в случае наличия семейного анамнеза рака молочнойжелезы,
                        мырекомендуем прохождение обследования, включающее маммографию. <br>
                        * Во все пакетыобследований стандартно включена копия компакт-диска CD.
                    </p>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="lang">
                <div class="info">
                    <div class="table">
                        <table>
                            <caption>РАСШИРЕННАЯПРОГРАММА</caption>
                            <colgroup>
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                                <col style="width: auto">
                                <col style="width: 10%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="3">Наименование обследований</th>
                                    <th scope="col">Стоимость</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th rowspan="2" scope="row" class="br">АПГРЕЙД</th>
                                    <td>Мужчины</td>
                                    <td class="left"><b class="color03">БАЗОВАЯПРОГРАММА</b>(Hизко-дозная компьютерная
                                        томография (КТ)
                                        легких + УЗИ щитовиднойжелезы) + KT органов брюшной полости и
                                        малого таза, Колоноскопия под седацией</td>
                                    <td>1,800,000 вон</td>
                                </tr>
                                <tr>
                                    <td>Женщины</td>
                                    <td class="left"><b class="color03">БАЗОВАЯПРОГРАММА</b>(Hизко-дозная компьютерная
                                        томография (КТ)
                                        органов грудной клетки + УЗИ щитовиднойжелезы) + УЗИмолочных
                                        желез, KT органов брюшной полости и малого таза, Колоноскопия
                                        под седацией</td>
                                    <td>2,280.000 вон</td>
                                </tr>

                                <tr>
                                    <th rowspan="2" scope="row" class="br">АПГРЕЙДПЛЮС</th>
                                    <td>Мужчины</td>
                                    <td class="left"><b class="color03">АПГРЕЙД</b>+ УЗИсонных артерий, Кардио-КТ
                                        (коронарная артерия
                                        в 3D визуализации), Магнитно-резонансная томография (МРТ)
                                        головногомозга + Магнитно-резонансная ангиография (MPA) сосудов
                                        головного мозга</td>
                                    <td>3,800,000 вон</td>
                                </tr>
                                <tr>
                                    <td>Женщины</td>
                                    <td class="left"><b class="color03">АПГРЕЙД</b>+ УЗИсонных артерий, Кардио-КТ
                                        (коронарная артерия
                                        в 3D визуализации), Магнитно-резонансная томография (МРТ)
                                        головногомозга + Магнитно-резонансная ангиография (MPA) сосудов
                                        головного мозга</td>
                                    <td>4,250,000 вон</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="lang">
                <div class="info">
                    <div class="table table-border02 table-bg01">
                        <table>
                            <caption>РАСШИРЕННАЯПРОГРАММА ПРЕМИУМ</caption>
                            <colgroup>
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                                <col style="width: auto">
                                <col style="width: 10%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="3">Наименование обследований</th>
                                    <th scope="col">Стоимость</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="rowgroup" rowspan="2" class="br">ПРЕМИУМ</th>
                                    <td>Мужчины</td>
                                    <td class="left"><b class="color03">АПГРЕЙД ПЛЮС</b> + ПЭТ-КТ головного мозга и
                                        всего тела, УЗИсердца,
                                        анализ на мужские гормоны, 1 ночь проживания в VIP палате</td>
                                    <td>6,200,000 вон</td>
                                </tr>
                                <tr>
                                    <td>Женщины</td>
                                    <td class="left"><b class="color03">АПГРЕЙД ПЛЮС</b> + ПЭТ-КТ головного мозга и
                                        всего тела, УЗИсердца,
                                        анализ наженские гормоны, 1 ночь проживания в VIP палате</td>
                                    <td>6,700,000 вон</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="lang">
                <div class="info">
                    <div class="table">
                        <table>
                            <caption>РАСШИРЕННАЯПРОГРАММА
                                ДИАМАНТ</caption>
                            <colgroup>
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                                <col style="width: auto">
                                <col style="width: 10%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="3">Наименование обследований</th>
                                    <th scope="col">Стоимость</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="rowgroup" rowspan="2" class="br">ДИАМАНТ</th>
                                    <td>Мужчины</td>
                                    <td class="left"><b class="color03">ПРЕМИУМ</b> + МРТ шейного и поясничного
                                        отделов + 1 ночь проживания
                                        в VIP палате</td>
                                    <td>7,750,000 вон</td>
                                </tr>
                                <tr>
                                    <td>Женщины</td>
                                    <td class="left"><b class="color03">ПРЕМИУМ</b> + МРТ шейного и поясничного
                                        отделов + 1 ночь проживания
                                        в VIP палате</td>
                                    <td>8,200,000 вон</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="lang">
                <div class="info">
                    <p class="table-top-text">выбираются как дополнение к выбранной программе комплексного обследования</p>
                    <div class="table">
                        <table>
                            <caption>Дополнительные обследования
                                (выбираются как дополнение к выбранной
                                программе комплексного обследования)</caption>
                            <colgroup>
                                <col style="width: 10%;">
                                <col style="width: 20%;">
                                <col style="width: auto">
                                <col style="width: 30%;">
                                <col style="width: 10%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="4">Наименование обследований</th>
                                    <th scope="col">Стоимость<br>(вон)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="rowgroup" rowspan="6" class="br">
                                        Обследование<br>желудочно-<br>кишечного<br>тракта</th>
                                    <td rowspan="4" class="br">Эндоскопические<br>исследования</td>
                                    <td class="left">Инъекция седативного
                                        препарата (при проведении
                                        эзофагогастродуоденоскопии
                                        (ЭГДС)</td>
                                    <td rowspan="4">*Во время проведения
                                        обследования, по
                                        решению врача, при
                                        обнаружении полипа,
                                        может потребоваться
                                        его удаление, а также
                                        взятие ткани на пробу
                                        для проведения биопсии,
                                        что влечет за собой
                                        дополнительные расходы</td>
                                    <td>120,000</td>
                                </tr>
                                <tr>
                                    <td class="left">Инъекция седативного препарата
                                        (при проведении колоноскопии)</td>
                                    <td>120,000</td>
                                </tr>
                                <tr>
                                    <td class="left">Инъекция седативного
                                        препарата (при проведении
                                        эзофагогастродуоденоскопии +
                                        колоноскопии)</td>
                                    <td>150,000</td>
                                </tr>
                                <tr>
                                    <td class="left">Колоноскопия</td>
                                    <td>260,000</td>
                                </tr>
                                <tr>
                                    <td>Ультразвуковое<br>
                                        исследование (УЗИ)</td>
                                    <td class="left">УЗИорганов брюшной полости</td>
                                    <td></td>
                                    <td>250,000</td>
                                </tr>
                                <tr>
                                    <td>Компьютерная<br>
                                        томография (КТ)</td>
                                    <td class="left">KT органов брюшной полости и
                                        малого таза</td>
                                    <td>с использованием
                                        контрастного вещества</td>
                                    <td>370,000</td>
                                </tr>
                                <tr>
                                    <th scope="rowgroup" rowspan="3">Диагностика<br>заболеваний<br>головного<br>мозга
                                    </th>
                                    <td rowspan="5" class="br">Магнитно-
                                        резонансная
                                        томография (МРТ)</td>
                                    <td class="left">MPT головного мозга</td>
                                    <td></td>
                                    <td>850,000</td>
                                </tr>
                                <tr>
                                    <td class="left">Магнитно-резонансная
                                        ангиография (MPA) сосудов
                                        головного мозга</td>
                                    <td></td>
                                    <td>850,000</td>
                                </tr>
                                <tr>
                                    <td class="left">MPT+MPA головного мозга</td>
                                    <td></td>
                                    <td>1,500,000</td>
                                </tr>
                                <tr>
                                    <th rowspan="2">Обследование<br>
                                        шейно-<br>
                                        поясничного<br>
                                        отдела<br>
                                        позвоночника</th>
                                    <td class="left">МРТ шейного отдела позвоночника</td>
                                    <td></td>
                                    <td>850,000</td>
                                </tr>
                                <tr>
                                    <td class="left">МРТ поясничного отдела
                                        позвоночника</td>
                                    <td></td>
                                    <td>850,000</td>
                                </tr>
                                <tr>
                                    <th scope="rowgroup" rowspan="3" class="br">Диагностика<br>заболеваний<br>сердца
                                    </th>
                                    <td rowspan="2" class="br">Ультразвуковое<br>
                                        исследование (УЗИ)</td>
                                    <td class="left">Эхокардиография сердца (ЭхоКГ)</td>
                                    <td></td>
                                    <td>300,000</td>
                                </tr>
                                <tr>
                                    <td class="left">УЗИсонных артерий</td>
                                    <td></td>
                                    <td>220,000</td>
                                </tr>
                                <tr>
                                    <td>Компьютерная<br>
                                        томография (КТ)</td>
                                    <td class="left">Кардио-КТ (коронарная артерия в
                                        3D визуализации)</td>
                                    <td>с использованием
                                        контрастного вещества</td>
                                    <td>400,000</td>
                                </tr>
                                <tr>
                                    <th colspan="3">Позитронно-эмиссионная томография, совмещенная с компьютерной
                                        томографией (ПЭТ-КТ) головногомозга и всего тела</th>
                                    <td>с использованием радиоактивного вещества</td>
                                    <td>1,700,000</td>
                                </tr>
                                <tr>
                                    <th scope="rowgroup" rowspan="2" class="br">Обследование<br>
                                        шейно-<br>
                                        поясничного<br>
                                        отдела позвоночника</th>
                                    <td rowspan="3" class="br">Компьютерная<br>
                                        томография (KT)</td>
                                    <td class="left">KT шейного отдела позвоночника</td>
                                    <td></td>
                                    <td>230,000</td>
                                </tr>
                                <tr>
                                    <td class="left">КТ поясничного отдела позвоночника</td>
                                    <td></td>
                                    <td>230,000</td>
                                </tr>
                                <tr>
                                    <th>Обследование<br>
                                        органов<br>
                                        грудной клетки</th>
                                    <td class="left">Hизко-дозная компьютерная
                                        томография (КТ) легких</td>
                                    <td></td>
                                    <td>220,000</td>
                                </tr>
                                <tr>
                                    <th colspan="3">Ультразвуковое исследование (УЗИ) щитовидной железы</th>
                                    <td></td>
                                    <td>220,000</td>
                                </tr>
                                <tr>
                                    <th scope="rowgroup" rowspan="2" class="br">Обследования<br>
                                        длямужчинин</th>
                                    <td>Предстательная
                                        железа</td>
                                    <td class="left">Ультразвуковое исследование
                                        (УЗИ) предстательнойжелезы</td>
                                    <td></td>
                                    <td>230,000</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="left">Анализ на мужские гормоны</td>
                                    <td></td>
                                    <td>180,000</td>
                                </tr>
                                <tr>
                                    <th scope="rowgroup" rowspan="2" class="br">Обследования<br>
                                        для женщин</th>
                                    <td>Молочнаяжелеза</td>
                                    <td class="left">Ультразвуковое исследование
                                        (УЗИ) молочныхжелез</td>
                                    <td></td>
                                    <td>260,000</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="left">Анализ наженские гормоны</td>
                                    <td></td>
                                    <td>200,000</td>
                                </tr>
                                <tr>
                                    <th>Другое</th>
                                    <td>Обследование здоровья с
                                        проживанием в одну ночь</td>
                                    <td class="left">VIP палата</td>
                                    <td>скидки не применимы</td>
                                    <td>500,000</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>
<script>
export default {

}
</script>